import http from '../../../../utils/andromeda-api';

const AUTOFOOTER_LINK = 'Autofooter Preference Page Link';

export const mapActivitiesToRows = activities => {
  if (!activities) return [];

  const rows = [...activities].reverse().map(clickActivity => ({
    _id: `${clickActivity.link}-${clickActivity.index}`,
    link: clickActivity.link,
    linkIndex: clickActivity.linkIndex + 1,
    displayOrder: clickActivity.linkIndex + 1,
    totalClicks: clickActivity.totalClicks,
    uniqueClicks: clickActivity.uniqueClicks,
  }));

  if (rows.length <= 1) return rows;

  const autofooterIdx = rows.findIndex(r => r.link === AUTOFOOTER_LINK);
  if (autofooterIdx !== -1) {
    const maxDisplayOrder = Math.max(
      ...rows.filter((_, i) => i !== autofooterIdx).map(r => r.displayOrder)
    );
    // linkIndex stays as the canonical API index; only displayOrder is bumped
    // to push the autofooter row to the bottom of the table.
    rows[autofooterIdx] = {
      ...rows[autofooterIdx],
      displayOrder: maxDisplayOrder + 1,
    };
  }

  return rows;
};

export const fetchEventsData = async ({ messageId, search }) => {
  const {
    data: { data },
  } = await http.get('/click/events', {
    params: { messageId, search },
  });

  return data;
};

export const fetchClickActivity = async ({ messageId, index }) => {
  const {
    data: { result },
  } = await http.get('/click/events/link', {
    params: { messageId, index },
  });

  return result;
};

export const exportEvents = async ({ messageId, urlIndexes }) => {
  const { data } = await http.post('/click/events/export', {
    messageId,
    urlIndexes,
  });

  // Andromeda returns { status, data: [...] }; return the rows array for CSV
  return Array.isArray(data?.data) ? data.data : data;
};
